import axios, { AxiosRequestConfig } from 'axios';
import { Reducer, useEffect, useReducer } from 'react';

import {
    DEFAULT_INITIAL_STATE,
    UseFetchAction,
    UseFetchReducer,
    UseFetchState
} from './useFetchReducer';

const useFetch = (query: AxiosRequestConfig): UseFetchState => {
    const [
        fetchState,
        dispatchFetchAction
    ] = useReducer<Reducer<
        UseFetchState,
        UseFetchAction
    >>(UseFetchReducer, DEFAULT_INITIAL_STATE);

    useEffect(() => {
        const cancelRequest = false;
        if (!query) return;

        const fetchData = async () => {
            dispatchFetchAction({ type: 'START_FETCH' });

            try {
                const response = await axios(query);

                if (cancelRequest) return;

                if (response.status === 200) {
                    return dispatchFetchAction({
                        type: 'FETCH_SUCCESS',
                        payload: { data: response.data }
                    });
                }

                return dispatchFetchAction({
                    type: 'FETCH_ERROR',
                    payload: { error: 'Server could not return requested data' }
                });
            } catch (err) {
                if (cancelRequest) return;

                return dispatchFetchAction({
                    type: 'FETCH_ERROR',
                    payload: { error: err }
                });
            }
        };

        if (!fetchState.isFetching && !fetchState.data) {
            fetchData();
        }

        // return () => {cancelRequest = true };
    }, [query]);

    return {
        isFetching: fetchState.isFetching,
        data: fetchState.data,
        error: fetchState.error
    };
};

export default useFetch;